module.exports = __webpack_public_path__ + "static/mandelas-way-feddb93e148675211c2f46d3a0e94564.jpg";